export default __webpack_public_path__ + "e571e7ea6f0eef0535c3ccc427d7c55d.svg";